import { SharedMenu } from 'modules/shared-menu/types';

import { CreateCategoryPayload, EditCategoryPayload } from './types';
import { convertLocalIsoDateToUtcIsoDate, updatePrimaryLanguageTranslation } from './utils';
import { ValidCategoryFormValues } from './validationSchemas';
import { SelectionCategory } from '../../types';

export const fromAddCategoryFormValuesToApi = (
  validValues: ValidCategoryFormValues,
  primaryLanguage: Language,
  imageUrl: string | null,
): CreateCategoryPayload => ({
  name: updatePrimaryLanguageTranslation(primaryLanguage, validValues.name, undefined),
  description: validValues.description
    ? updatePrimaryLanguageTranslation(primaryLanguage, validValues.description, undefined)
    : undefined,
  image: imageUrl ?? undefined,
});

export const fromEditCategoryFormValuesToApi = (
  category: SelectionCategory,
  validValues: ValidCategoryFormValues,
  primaryLanguage: Language,
  imageUrl: string | null,
): EditCategoryPayload => {
  const { version, id, scope, image, image_blurhash, subcategories, ...categoryAttrs } = category;
  return {
    ...categoryAttrs,
    name: updatePrimaryLanguageTranslation(primaryLanguage, validValues.name, category.name),
    description: validValues.description
      ? updatePrimaryLanguageTranslation(primaryLanguage, validValues.description, category.description)
      : undefined,
    image: imageUrl ?? undefined,
    offer_bindings: category.offer_bindings && category.offer_bindings.length > 0 ? category.offer_bindings : undefined,
  };
};

export const buildUpdateSharedMenuInfoPayload = (scheduleValue: string | undefined, selection: SharedMenu) => {
  return {
    name: selection.name,
    primary_language: selection.primary_language,
    draft: {
      ...selection.draft,
      publish_at: scheduleValue ? convertLocalIsoDateToUtcIsoDate(scheduleValue) : undefined,
    },
    categoryIds: selection.categories.map(category => category.id),
  };
};
